import React from "react";
import { DisconnectionFormValues } from "../../../../types/DisconnectionFormValues";
import { Flex } from "../../../Flex";
import { Title } from "../../../Title";
import { ReviewFormSection } from "../../../LiveningIcpForm/_/LiveningIcpReviewForm/_/ReviewFormSection";
import { ReviewFormPropertyDetails } from "./_/ReviewFormPropertyDetails";
import { ReviewFormDisconnectionDetails } from "./_/ReviewFormDisconnectionDetails";
import { ReviewFormUploadPhotos } from "./_/ReviewFormUploadPhotos";
import { ReviewFormDisconnectionContactDetails } from "./_/ReviewFormDisconnectionContactDetails";
import { ReviewFormDeclarations } from "./_/ReviewFormDeclarations";

interface Props {
  values: DisconnectionFormValues;
  onEdit: (elementId: string) => void;
  onSelectTermsConditions: (checked: boolean) => void;
}

const PROPERTY_DETAILS_SECTION =
  "disconnection-order-details-form-property-details-section";

const DISCONNECTION_DETAILS_SECTION =
  "disconnection-order-details-form-disconnection-details-section";

const UPLOAD_PHOTOS_SECTION =
  "disconnection-order-details-form-upload-photos-section";

const CONTACTS_SECTION =
  "disconnection-order-details-form-contact-details";

export const DisconnectionReviewForm: React.FC<Props> = ({
  values,
  onEdit,
  onSelectTermsConditions,
}) => {
  const handleOnEdit = (elementId: string) => () => {
    onEdit(elementId);
  };

  return (
    <Flex flexDirection="column" mr={[0, 0, 0, 3]}>
      <Title as="h1" lineHeight={7} fontWeight="medium" mb={5}>
        {"Review & Submit"}
      </Title>

      <ReviewFormSection
        id="disconnection-review-form-property-details"
        title="Property details"
        data-testid="decom-review-form-property-details"
        onEditClick={handleOnEdit(PROPERTY_DETAILS_SECTION)}
      >
        <ReviewFormPropertyDetails
          id={"disconnection-review-form-property-details-section"}
          values={values.propertyDetails}
        />
      </ReviewFormSection>

      <ReviewFormSection
        id="disconnection-review-form-disconnection-details"
        title="Disconnection details"
        data-testid="disconnection-review-form-disconnection-details"
        onEditClick={handleOnEdit(DISCONNECTION_DETAILS_SECTION)}
      >
        <ReviewFormDisconnectionDetails
          id={"disconnection-review-form-disconnection-details-section"}
          values={values.disconnectionDetails}
        />
      </ReviewFormSection>

      <ReviewFormSection
        id="disconnection-review-form-upload-photos"
        title="Upload photos"
        data-testid="disconnection-review-form-upload-photos"
        onEditClick={handleOnEdit(UPLOAD_PHOTOS_SECTION)}
      >
        <ReviewFormUploadPhotos
          id={"disconnection-review-form-upload-photos-section"}
          uploads={values.disconnectionDetails.meterPhotos}
        />
      </ReviewFormSection>

      <ReviewFormSection
        id="disconnection-review-form-contacts"
        title="Contact details"
        data-testid="disconnection-review-form-contacts"
        onEditClick={handleOnEdit(CONTACTS_SECTION)}
      >
        <ReviewFormDisconnectionContactDetails
          id={"disconnection-review-form-contacts-section"}
          contactDetails={values.contactDetails}
        />
      </ReviewFormSection>

      <ReviewFormDeclarations
        id={"disconnection-review-form-declarations-section"}
        onSelectTermsConditions={onSelectTermsConditions}
      />
    </Flex>
  );
};
